import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import { getAvailableModelConfigurations, getUnavailableModelConfigurations } from '@modules/ai/common/model-definitions';
import { ProviderModels } from '../common/provider-models';
import { HuggingFaceModelConfigurationDialog } from './hugging-face-model-configuration-dialog/hugging-face-model-configuration-dialog';
const columns = [
    { title: 'ID', id: 'id' },
    { title: 'Model URL', id: 'url', maxWidth: 308 }
];
export function HuggingFaceAiProviderForm(props) {
    var _a, _b;
    const { form, className, availableProvider } = props;
    const modelConfigurations = getAvailableModelConfigurations((_a = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) !== null && _a !== void 0 ? _a : []);
    const unsupportedModelConfigurations = getUnavailableModelConfigurations((_b = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) !== null && _b !== void 0 ? _b : []);
    const controller = useController({ name: 'provider.huggingFace.models', control: form.control });
    return (_jsx("section", { className: classNames(className), children: _jsx(ProviderModels, { modelDialogComponent: HuggingFaceModelConfigurationDialog, columns: columns, modelConfigurations: modelConfigurations, unsupportedModelConfigurations: unsupportedModelConfigurations, modelsController: controller }) }));
}
